import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../../../../CommonComponents/Modal';
import { ModalContent } from './DarkWebModalStyles';
import IndexView from './Views/IndexView';
import BankAccountForm from './Views/BankAccountForm';
import EmailsForm from './Views/EmailForm';
import CreditCardForm from './Views/CreditCardForm';
import MedicalIdForm from './Views/MedicalIdForm';
import IbanForm from './Views/IbanForm';
import PassportNumberForm from './Views/PassportNumberForm';
import TelephoneNumberForm from './Views/TelephoneNumberForm';
import DriverLicenseForm from './Views/DriverLicenseForm';
import { Alert } from '../../../../../CommonComponents/Alert/Alert';
import { VIEWS } from '../DarkWebConstants';
import { darkWebModalErrorsSelector } from '../../../../ExperianSelector';
import { setDarkWebModalErrors } from '../../../../ExperianActions';

const DarkWebModal = ({ isOpen, onRequestClose, hasDriverLicense, hasPassportNumber }) => {
  const [view, setView] = useState('index');

  const darkWebModalErrors = useSelector(darkWebModalErrorsSelector);

  const dispatch = useDispatch();
  const onCancelCallback = useCallback(() => {
    setView(VIEWS.INDEX);
    dispatch(setDarkWebModalErrors([]));
  }, [dispatch]);

  useEffect(() => {
    if (!isOpen) {
      setView(VIEWS.INDEX);
      dispatch(setDarkWebModalErrors([]));
    }
  }, [isOpen, dispatch]);

  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose} showCloseModalCross>
      <ModalContent>
        {darkWebModalErrors.length > 0 && <Alert message={darkWebModalErrors} />}
        {(() => {
          switch (view) {
            case VIEWS.INDEX:
              return (
                <IndexView
                  hasDriverLicense={hasDriverLicense}
                  hasPassportNumber={hasPassportNumber}
                  setView={setView}
                />
              );
            case VIEWS.BANK_ACCOUNTS:
              return (
                <BankAccountForm onCancel={onCancelCallback} onRequestClose={onRequestClose} />
              );
            case VIEWS.CREDIT_CARDS:
              return <CreditCardForm onCancel={onCancelCallback} onRequestClose={onRequestClose} />;
            case VIEWS.EMAILS:
              return <EmailsForm onCancel={onCancelCallback} onRequestClose={onRequestClose} />;
            case VIEWS.MEDICAL_IDS:
              return <MedicalIdForm onCancel={onCancelCallback} onRequestClose={onRequestClose} />;
            case VIEWS.IBANS:
              return <IbanForm onCancel={onCancelCallback} onRequestClose={onRequestClose} />;
            case VIEWS.PASSPORT_NUMBER:
              return (
                <PassportNumberForm onCancel={onCancelCallback} onRequestClose={onRequestClose} />
              );
            case VIEWS.TELEPHONES:
              return (
                <TelephoneNumberForm onCancel={onCancelCallback} onRequestClose={onRequestClose} />
              );
            case VIEWS.DRIVER_LICENSE:
              return (
                <DriverLicenseForm onCancel={onCancelCallback} onRequestClose={onRequestClose} />
              );
            default:
              return null;
          }
        })()}
      </ModalContent>
    </Modal>
  );
};

DarkWebModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  hasDriverLicense: PropTypes.bool.isRequired,
  hasPassportNumber: PropTypes.bool.isRequired,
};

export default DarkWebModal;
